import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import StyledModal from '../styled_modal';

const ErrorDialog = ({ children, title, show, handleClose }) => (
  <StyledModal show={show} onHide={handleClose}>
    <StyledModal.Header hasTitle={Boolean(title)}>
      {title && <StyledModal.Title>{title}</StyledModal.Title>}
    </StyledModal.Header>
    <StyledModal.Body>{children}</StyledModal.Body>
    <StyledModal.Footer>
      <Button variant="primary" className="w-100" onClick={handleClose}>
        Close
      </Button>
    </StyledModal.Footer>
  </StyledModal>
);

export default ErrorDialog;

ErrorDialog.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
